import styled from 'styled-components';

export const ServiceDetailPageContainer = styled.div`
  padding: 8rem 2rem;
  max-width: 900px;
  margin: 0 auto;
  text-align: left;
  line-height: 1.8;

  h1 {
    font-size: 3.5rem;
    color: #1f2937;
    margin-bottom: 1.5rem;
    background: linear-gradient(45deg, #00B4DB, #007bff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
  }

  h2 {
    font-size: 2.5rem;
    color: #1f2937;
    margin-top: 3rem;
    margin-bottom: 1rem;
  }

  h3 {
    font-size: 1.8rem;
    color: #1f2937;
    margin-top: 2rem;
    margin-bottom: 0.8rem;
  }

  p {
    font-size: 1.1rem;
    color: #4b5563;
    margin-bottom: 1rem;
  }

  ul {
    list-style: disc;
    margin-left: 2rem;
    margin-bottom: 1rem;

    li {
      font-size: 1.1rem;
      color: #4b5563;
      margin-bottom: 0.5rem;
    }
  }

  b {
    color: #00B4DB;
  }
`;

export const ServiceImage = styled.img`
  max-width: 200px; /* Smaller size */
  height: auto;
  border-radius: 0; /* Remove border-radius */
  margin: 0.5rem 0 1rem 2rem; /* Adjusted margin for text wrapping */
  box-shadow: none; /* Remove box-shadow */
  float: right; /* Allow text to wrap around */

  @media (max-width: 768px) {
    float: none;
    margin: 1rem auto;
    max-width: 80%;
    display: block;
  }
`; 